var exports = {
  "k": "xaf9ae18d--e73f8d--container",
};

module.exports = exports;
